var map = {
	"./1.26 FOTO 1.jpg": 785,
	"./1.28 FOTO 3.png": 786,
	"./3.1 KC Tribunj 1-14.08.2025. – kopija.png": 787,
	"./3.1 KC Tribunj 1-14.08.2025..png": 788,
	"./3.2 KC Tribunj 2-14.08.2025..png": 789,
	"./3.3 KC Tribunj 3-14.08.2025..png": 790,
	"./3.4 KC Tribunj 4-14.08.2025.JPG": 791,
	"./3.5 KC Tribunj 5-14.08.2025.JPG": 792,
	"./3.6 KC Tribunj 6-14.08.2025.jpg": 793,
	"./3.7 KC Tribunj 7-14.08.2025.jpg": 794,
	"./FOTO 3.1.png": 795,
	"./FOTO 3.5.jpg": 796,
	"./FOTO 3.6.png": 797,
	"./FOTO 3.7.jpg": 798,
	"./FOTO 3.8.jpg": 799,
	"./FOTO 3.9.jpg": 800
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 784;